
import React, { useContext } from 'react';
import { Page, PageContextType } from '../types';
import { PageContext } from '../PageContext';
import { useChat } from '../ChatContext';
import { useAuth } from '../AuthContext';
import { useAppContext } from '../AppContext';

interface HeaderProps {
    title: string;
}

const MultiColorTitle: React.FC<{ text: string }> = ({ text }) => {
    return (
        <h1 className="text-xl font-extrabold tracking-wider">
            <span className="aurora-text">
                {text.toUpperCase()}
            </span>
        </h1>
    );
};


const Header: React.FC<HeaderProps> = ({ title }) => {
    const pageContext = useContext(PageContext);
    const { pageStack } = pageContext ?? { pageStack: [] };
    const currentPageState = pageStack[pageStack.length - 1];
    const { totalUnreadCount } = useChat();
    const { userProfile } = useAuth();
    const { appConfig } = useAppContext();

    const goToSettings = () => {
        // If guest, redirect to login
        if (!userProfile) {
            pageContext?.switchPage(Page.Login, 'Sign In');
            return;
        }
        pageContext?.switchPage(Page.Settings, 'Settings');
    };
    
    const goToMessages = () => {
        if (!userProfile) {
            pageContext?.switchPage(Page.Login, 'Sign In');
            return;
        }
        pageContext?.switchPage(Page.ChatList, 'Messages');
    };
        
    return (
        // Added pt-[max(1rem,env(safe-area-inset-top))] to handle iPhone notch and Android status bars natively
        <header className="flex-shrink-0 flex items-center justify-between p-4 pt-[max(1rem,env(safe-area-inset-top))] shadow-md z-10" style={{ backgroundColor: 'var(--primary-dark-purple)'}}>
            {/* Logo Button */}
            <button id="tour-logo" onClick={() => pageContext?.switchPage(Page.Home, 'Home')} className="w-10 h-10 flex items-center justify-center transition-transform hover:scale-110 active:scale-100" aria-label="Go to Home">
                {appConfig.logoUrl && (
                    <img 
                        src={appConfig.logoUrl} 
                        alt="App Logo" 
                        className="w-full h-full object-contain drop-shadow-md"
                        referrerPolicy="no-referrer"
                    />
                )}
            </button>
            
            <div className="flex-1 text-center mx-2 min-w-0">
                 <MultiColorTitle text={title} />
            </div>

            <div className="flex items-center space-x-4 w-20 justify-end">
                <button onClick={goToMessages} className="relative">
                    <i className="ph-duotone ph-paper-plane-tilt text-2xl text-white hover:text-[var(--accent-pink)] transition-colors"></i>
                    {totalUnreadCount > 0 && (
                        <span className="absolute -top-2 -right-2 bg-red-500 text-white text-[10px] font-bold rounded-full h-4 w-4 flex items-center justify-center border border-[var(--primary-dark-purple)]">
                            {totalUnreadCount}
                        </span>
                    )}
                </button>
                <button onClick={goToSettings}>
                    <i className="ph-duotone ph-gear text-2xl text-white hover:text-[var(--accent-pink)] transition-colors"></i>
                </button>
            </div>
        </header>
    );
};

export default Header;